import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina M.',
    role: 'Mamá de un Golden',
    text: 'Nunca pensé que podría tejer algo tan parecido a mi Max. Las instrucciones para las manchas fueron clave. Ahora tengo a mi viejito inmortalizado.'
  }, {
    name: 'Sofía R.',
    role: 'Emprendedora Crochet',
    text: 'Mis clientas enloquecieron cuando empecé a ofrecer mascotas personalizadas. Este ebook se pagó solo con el primer pedido.'
  }, {
    name: 'Elena V.',
    role: 'Amante de los gatos',
    text: 'Los patrones de gatos suelen ser raros, pero el del Siamés es perfecto. La forma de la cara es tal cual. ¡Gracias!'
  }];
  return <section id="testimonios" className="py-10 md:py-16 bg-linen" data-id="element-368">
      <div className="max-w-5xl mx-auto px-4" data-id="element-369">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-370">
          <p className="text-sm font-bold tracking-[0.2em] text-copper uppercase mb-4" data-id="element-371">
            Reseñas
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-372">
            Historias de amor tejidas
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-373">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="etsy-card p-7" data-id="element-374">
              <div className="flex gap-0.5 mb-4" data-id="element-375">
                {[...Array(5)].map((_, j) => <Star key={j} size={15} className="text-amber-400 fill-amber-400" data-id="element-376" />)}
              </div>
              <p className="text-gray-600 italic mb-6 leading-relaxed text-sm" data-id="element-377">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 border-t border-gray-50 pt-4" data-id="element-378">
                <div className="w-9 h-9 rounded-full bg-cream flex items-center justify-center font-bold text-copper text-xs" data-id="element-379">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-380">
                  <h4 className="font-bold text-deep-brown text-sm" data-id="element-381">
                    {t.name}
                  </h4>
                  <p className="text-xs text-gray-400" data-id="element-382">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}